import { useQuery } from '@tanstack/react-query';
import { getVehicleClaimStats } from '@/lib/vehicle-claims/api';
import type { VehicleClaimListFilters, VehicleClaimStatsResponse } from '@/types/vehicle-claim';

export const vehicleClaimStatsKeys = {
  all:  ['vehicle-claim-stats'] as const,
  list: (filters: VehicleClaimListFilters) => [...vehicleClaimStatsKeys.all, filters] as const,
};

/** Status/day counts for the vehicle-claims dashboard, scoped by the same filters as the claims list. */
export function useVehicleClaimStats(filters: VehicleClaimListFilters = {}) {
  return useQuery({
    queryKey: vehicleClaimStatsKeys.list(filters),
    queryFn:  () => getVehicleClaimStats(filters) as Promise<VehicleClaimStatsResponse>,
    staleTime: 30_000,
  });
}
